// import { useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { fetchUserData } from "utils/api";
// import { formatTodayWithWeekday } from "utils/formatDateTime";
// import "styles/Dashboard.css";

// import dashboardImage from "assets/main.png";
// import CardGrid from "./CardGrid";
// import PageHeader from "components/PageHeader";

// const Dashboard = () => {
//   const [userProfile, setUserProfile] = useState(null);
//   const [showSplash, setShowSplash] = useState(false);
//   const [fadeOut, setFadeOut] = useState(false);
//   const location = useLocation();

//   // Fetch profile on first load
//   useEffect(() => {
//     async function fetchProfile() {
//       try {
//         const profile = await fetchUserData();
//         setUserProfile(profile);
//       } catch (err) {
//         console.error("Error fetching profile in Dashboard:", err);
//         setUserProfile({});
//       }
//     }
//     fetchProfile();
//   }, []);

//   // Show splash once per login session
//   useEffect(() => {
//     if (
//       location.pathname === "/dashboard" &&
//       !sessionStorage.getItem("acknowledgmentSeen")
//     ) {
//       setShowSplash(true);
//       sessionStorage.setItem("acknowledgmentSeen", "true");
//     }
//   }, [location.pathname]);

//   //Splash fade animation
//   useEffect(() => {
//     if (showSplash && location.pathname === "/dashboard") {
//       const fadeTimer = setTimeout(() => setFadeOut(true), 4000);
//       const hideTimer = setTimeout(() => setShowSplash(false), 5000);
//       return () => {
//         clearTimeout(fadeTimer);
//         clearTimeout(hideTimer);
//       };
//     }
//   }, [showSplash, location.pathname]);

//   if (userProfile === null) {
//     return <p>Loading profile…</p>;
//   }

//   const firstName = userProfile.firstName || "User";
//   const today = formatTodayWithWeekday();

//   return (
//     <>
//       {location.pathname === "/dashboard" && (
//         <PageHeader title={`Welcome Back, ${firstName}!`} />
//       )}

//       {showSplash && location.pathname === "/dashboard" ? (
//         <div
//           className={`dashboard-image-container ${fadeOut ? "fade-out" : ""}`}
//         >
//           <img
//             src={dashboardImage}
//             alt="Acknowledgement"
//             className="dashboard-image"
//           />
//         </div>
//       ) : location.pathname === "/dashboard" ? (
//         <CardGrid />
//       ) : null}
//     </>
//   );
// };

// export default Dashboard;

import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { fetchUserData } from "utils/api";
import { formatTodayWithWeekday } from "utils/formatDateTime";
import "styles/Dashboard.css";

import dashboardImage from "assets/main.png";
import CardGrid from "./CardGrid";
import PageHeader from "components/PageHeader";
import { BIOBANK_ROUTES } from "../../../constants/routes";
import { useTour } from "tour/TourProvider";

const maroon = "#500000";

const Dashboard = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [showSplash, setShowSplash] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const location = useLocation();
  const { startBiobankTour } = useTour();

  // Fetch profile on first load
  useEffect(() => {
    async function fetchProfile() {
      try {
        const profile = await fetchUserData();
        setUserProfile(profile);
      } catch (err) {
        console.error("Error fetching profile in Dashboard:", err);
        setUserProfile({});
      }
    }
    fetchProfile();
  }, []);

  // Show splash once per login session
  useEffect(() => {
    if (
      location.pathname === BIOBANK_ROUTES.DASHBOARD &&
      !sessionStorage.getItem("acknowledgmentSeen")
    ) {
      setShowSplash(true);
      sessionStorage.setItem("acknowledgmentSeen", "true");
    }
  }, [location.pathname]);

  // Splash fade animation
  useEffect(() => {
    if (showSplash && location.pathname === BIOBANK_ROUTES.DASHBOARD) {
      const fadeTimer = setTimeout(() => setFadeOut(true), 4000);
      const hideTimer = setTimeout(() => setShowSplash(false), 5000);
      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(hideTimer);
      };
    }
  }, [showSplash, location.pathname]);

  if (userProfile === null) {
    return (
      <Box
        sx={{
          p: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            border: "4px solid #f3f3f3",
            borderTop: `4px solid ${maroon}`,
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px",
          }}
        />
        <Typography variant="h6" sx={{ color: maroon }}>
          Loading profile...
        </Typography>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </Box>
    );
  }

  const firstName = userProfile.firstName || "User";
  const today = formatTodayWithWeekday();

  return (
    <>
      {location.pathname === BIOBANK_ROUTES.DASHBOARD && (
        <PageHeader
          title={`Welcome Back, ${firstName}!`}
          subtitle={`Today's Date: ${today}`}
          actions={
            <Button
              variant="outlined"
              startIcon={<HelpOutlineIcon />}
              onClick={() => startBiobankTour()}
              sx={{
                fontWeight: 600,
                height: "40px",
                px: 3,
                fontSize: "14px",
                whiteSpace: "nowrap",
                borderColor: "#500000",
                color: "#500000",
                "&:hover": { borderColor: "#3a0000", backgroundColor: "#fdf6e3" },
              }}
            >
              Take the Tour
            </Button>
          }
        />
      )}

      {showSplash && location.pathname === BIOBANK_ROUTES.DASHBOARD ? (
        <div
          className={`dashboard-image-container ${fadeOut ? "fade-out" : ""}`}
        >
          <img
            src={dashboardImage}
            alt="Acknowledgement"
            className="dashboard-image"
          />
        </div>
      ) : location.pathname === BIOBANK_ROUTES.DASHBOARD ? (
        <CardGrid />
      ) : null}
    </>
  );
};

export default Dashboard;